import { Component, Inject, OnInit,NgZone,EventEmitter, Optional } from '@angular/core';
// import { BaseFpxComponentState, BaseFpxFormComponent, BaseFpxFormHelper, BaseFpxPostSubmitInterceptor, HttpProviderService, RoutingInfo } from "@fpx/core";  
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder,Validators,ControlContainer,FormGroup  } from '@angular/forms';
import { CANCEL_LABEL, OK_LABEL } from '@common/constants';
import { IConfirmationDialogData } from 'src/app/core/models/dialog.model';
import { Router } from '@angular/router';
import { CommonService } from 'src/app/common.service';
import { DebitCardTabContainerComponent } from 'src/app/cards/debit-card-tab-container/debit-card-tab-container.component';
import { PreLoginService } from 'src/app/pre-login/pre-login.service';
import { NativeStorageService } from "src/app/services/mobile/native-storage.service";
import { ServiceStock } from 'src/app/service-stock.service';
import { MobileService } from 'src/app/mobile.services';
// import { DcServiceRequestFormControlHelper, DcServiceRequestFormControlState } from 'src/app/debit-card/dc-service-request-form/dc-service-request-form.helper';
// import { DcServiceRequestFormControlHelper,DcServiceRequestFormControlState} from 'src/app/debit-card/dc-service-request-form.helper';

declare var entrust: any;
declare var $: any;
@Component({
  selector: 'app-confirmation',
  templateUrl: './confirmation.component.html',
  styleUrls: ['./confirmation.component.scss']
  // providers: [DcServiceRequestFormControlHelper]
})
// export class ConfirmationComponent extends BaseFpxFormComponent<DcServiceRequestFormControlHelper, DcServiceRequestFormControlState> implements OnInit {
  export class ConfirmationComponent implements OnInit {

  okLabel:string = "";
  cancelLabel:string = "";
  title:string = "";
  message:string = "";
  cardRefNo:string="";
  cardCategory:string="";
  doShowQuickActions: boolean = false;

  constructor(
    // @Optional() controlContainer: ControlContainer,
    // formBuilder: FormBuilder,
    // public dcServiceRequestFormControlHelper: DcServiceRequestFormControlHelper,
    private dialogRef: MatDialogRef<ConfirmationComponent>, 
    private DebitCardTab: DebitCardTabContainerComponent, 
    private ngZone: NgZone,
    private router: Router,
    protected _commonService: CommonService,
    private _preLoginService: PreLoginService,
    private _nativeStorage: NativeStorageService,
    public services: ServiceStock,
    private mobileService: MobileService,
    @Inject(MAT_DIALOG_DATA) private data: IConfirmationDialogData
  ) {
    // super(formBuilder, router,controlContainer, dcServiceRequestFormControlHelper);
  }

  ngOnInit(): void {
    this.okLabel = this.data.okLabel ? this.data.okLabel : OK_LABEL;
    this.cancelLabel = this.data.cancelLabel ? this.data.cancelLabel : CANCEL_LABEL;
    if (this.data.title.indexOf('-') > -1) { 
      var cardTitle=[];
      cardTitle=this.data.title.split('-') 
      this.title = cardTitle[0];
      this.cardRefNo=cardTitle[1];
      this.cardCategory = cardTitle[2];
      if(this.cardRefNo=="WALLET_FAILURE"){
        $('.button-ok').hide();
      }else if(this.title=="Token Details"){
        $('.button-cancel').hide();
      }
      } else if (this.data.title=="Token Details"){
        this.title = this.data.title;
        $('.button-cancel').hide();
      } else{
    this.title = this.data.title;
    }
    this.message = this.data.message;
  }

  ok(){
    if(this.title =="Unregister Card"){
     // this.unregisterCard("mc4211");
      this.unregisterCard(this.cardRefNo);
   //   this.dialogRef.close(1);
    //  this.doShowQuickActions = false;
    }else if(this.title =="Default Card"){
      // this.unregisterCard("mc4211");
       this.setDefaultCard(this.cardRefNo);
    //   this.dialogRef.close(1);
     //  this.doShowQuickActions = false;
    }else if(this.title =="Card Details"){
      this.showCardDetails(this.cardRefNo,this.cardCategory)
      this.dialogRef.close(1);
      this.doShowQuickActions = false;
    }
    else {
    this.dialogRef.close(1);
      this.doShowQuickActions = false;
    }
  }

  cancel(){
    this.dialogRef.close();
    if(this.cardRefNo=="WALLET_FAILURE"){
      //this._preLoginService.logout();
      }
  }

   unregisterCard(cardId){
    this._commonService.showSpinner();
var that = this;
    entrust.unregister(cardId,sCallback,fCallback);
    function sCallback(arg){
            console.log(arg);
            // alert("unregisterCardSuccess"+arg);
            // alert("Card is successfully unregsitered");
            that._commonService.hideSpinner();
            that.ngZone.run(() => {
              // that.DebitCardTab.nfcCardStatus(cardId);
              // that._commonService.hideSpinner();
              // that.router.navigate(["home", "cards"]);
              // that.DebitCardTab.isRegisterVal = true;
              // that.DebitCardTab.isCardStatusActVal = false;
              // that.DebitCardTab.isCardStatusDeactVal = false;
			  that.dialogRef.close(1);
			that.doShowQuickActions = false;
              that.router.navigateByUrl('/RefreshComponent', { skipLocationChange: true }).then(() => {
              that.router.navigate(["home", "cards"]);
            }); 
            });
            }
            function fCallback(arg){
              that._commonService.hideSpinner();
            console.log(arg);
           // alert("Your card is not yet registered for Tap & Pay");
		    $('.message').text('Card is not registered for Tap to Pay');
			that.title="";
			that.okLabel="Close"
			$('.button-cancel').hide();
            //instead of alert show pop-up with close button here
           // alert("unregisterCardFail "+arg);
    }
    }
    setDefaultCard(cardId){
      this._commonService.showSpinner();
      var that = this;
      entrust.setNfcCard(cardId, sCallback, fCallback);
     
      function sCallback(arg) {
        console.log(arg);
        that._commonService.hideSpinner();
        let cd = {
          cdId: cardId,
          tkn: arg.token
      }
        that._nativeStorage.storeData('default', cd).then((value)=>{

        });
        
        that.ngZone.run(() => {
          that.dialogRef.close(1);
          that.doShowQuickActions = false;
          that.router.navigateByUrl('/RefreshComponent', { skipLocationChange: true }).then(() => {
          that.router.navigate(["home", "cards"]);
        }); 
        });
      }
      function fCallback(error) { 
        that._commonService.hideSpinner();
        console.log(error);
      
    $('.message').text('Card is not registered for Tap to Pay.');
  that.title="";
  that.okLabel="Close"
  $('.button-cancel').hide();
       
      }
    }

    showCardDetails(cardRefNumber,cardCategory){
      //let navPath = ["process-shell", "debit-card", "dc-flash"];
      let navPath =["home","cards","process-shell", "debit-card", "dc-flash"]
      //if(!this._responsive.isMobile()) navPath.unshift('onboarding');
     // this._router.navigate(navPath);
    /*this._router.navigate(navPath, { 
      queryParams: {
      "referenceKey": this.state.cardRefNumber,
      "additionalDetails": ""
      }
      });*/
      if (this.services.mobile.isHybrid()) {
      if (this.mobileService.isDeviceRegistered) {
      this.mobileService.deviceAuth = new EventEmitter();
      this.mobileService.deviceAuth.subscribe(
        (deviceAuth) => {
        if (deviceAuth) {
          //TODO: device auth success
          let navPath =["home","cards","process-shell", "debit-card", "dc-flash"]
          this.router.navigate(navPath, { 
          queryParams: {
          "referenceKey": cardRefNumber,
          "cardCategory":cardCategory,
          "additionalDetails": ""
          }
          });
        } else {
          //TODO: show device auth error
         this.router.navigate(['home', 'cards']);
        }
        }, (err) => {
        //TODO: show device auth access error
        this.router.navigate(['home', 'cards']);
        }
      );
      this.mobileService.showTouchIDAuth();
      }
      else {
      // alert("The device is not registered for Biometrics, please register using Settings options of the app");
      let navPath =["home","cards","process-shell", "debit-card", "dc-flash"]
          this.router.navigate(navPath, { 
          queryParams: {
          "referenceKey": cardRefNumber,
          "cardCategory":cardCategory,
          "additionalDetails": ""
          }
          });
      //this._router.navigate(['home', 'cards']);
      }
    }
    }
}
